import { postToDTonomyAPI } from "../helpers/common";

export async function logUserProfile(userProfile){
    // Post to base.plugin DTonomy API
    if(userProfile){
      const displayName = userProfile.displayName;
      const emailAddress = userProfile.emailAddress;
      return await postToDTonomyAPI("log/user_profile/", {
        "name": displayName,
        "email": emailAddress,
        "plugin": "Outlook"
      });
    }
    else{
      console.log("The userProfile argument is undefined")
    }
  }
  
  export async function logEmailInfo(emailInfo){
    // Post to base.plugin DTonomy API
    if(emailInfo){
      let senderName, senderEmail, fromName, fromEmail, toNames, toEmails;
      if(emailInfo.sender){
        senderName = emailInfo.sender.displayName;
        senderEmail = emailInfo.sender.emailAddress;
      }
      if(emailInfo.from){
        fromName = emailInfo.from.displayName;
        fromEmail = emailInfo.from.emailAddress;
      }
      if(emailInfo.to){
        toNames = emailInfo.to.map(t => t.displayName).join(" | ");
        toEmails = emailInfo.to.map(t => t.emailAddress).join(" | ");
      }
      return await postToDTonomyAPI("log/email_info/", {
        "emailClientMessageId": emailInfo.emailClientMessageId,
        "messageId": emailInfo.messageId,
        "subject": emailInfo.subject,
        "senderName": senderName,
        "senderEmail": senderEmail,
        "fromName": fromName,
        "fromEmail": fromEmail,
        "toNames": toNames,
        "toEmails": toEmails,
        "deliveredToName": emailInfo.deliveredTo.displayName,
        "deliveredToEmail": emailInfo.deliveredTo.emailAddress,
        "plugin": "Outlook"
      });
    }
    else{
      console.log("The emailInfo argument is undefined")
    }
  }
  